import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'

// @TODO get service workers running
// import * as serviceWorker from './swInit';

import store, { persistor } from './store/store';
import App from './App';

if (process.env.REACT_APP_MODE === 'development') {
  localStorage.setItem('debug', 'ClusterWeb:*');
}

render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>,
  document.getElementById('cluster-web')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// serviceWorker.unregister();
// serviceWorker.register({firebaseMessaging: firebase.messaging, onRegistered: () => firebase.initMessaging()});